<template>
<div class="container pt-6 pl-6 pt-md-5 h-100">
  <div class="py-md-4">
  </div>
  <h2 class="font-size-2_5rem tracking-1 text-center mb-5 d-none d-md-block">TYPE &amp; NOTE</h2>
  <h2 class="d-md-none mobile-section-title">TYPE &amp; NOTE</h2>
  <div class="type-wrapper">
    <div class="p-relative" :style="typeContentStyle">
      <b-row>
        <b-col v-for="(type, i) in types" :key="type.id" sm="6" lg="4" class="mb-2 mb-md-4">
          <b-button variant="outline-dark" block @click="clickType(i)">
            {{ type.name}}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>

  <div class="d-flex d-md-none py-3 footer-control justify-content-center pl-5 ">
    <b-button variant="outline-dark" size="sm" class="mx-3" pill :disabled="!showP2" @click="showP2 = !showP2">
      <b-icon-chevron-up></b-icon-chevron-up>
    </b-button>
    <b-button variant="outline-dark" size="sm" class="mx-3" pill :disabled="showP2" @click="showP2 = !showP2">
      <b-icon-chevron-down></b-icon-chevron-down>
    </b-button>
  </div>
</div>
</template>

<script>
import {mapState, mapActions} from 'vuex'

export default {
  data() {
    return {
      // types: [],
      showP2: false
    }
  },
  mounted() {
    if(!this.types) {
      this.syncTypes(this.axios)
    }
  },
  computed: {
    ...mapState({
      types: state => state.types,
      typeMobileP2Showing: state => state.typeMobileP2Showing
    }),
    typeContentStyle() {
      if (this.showP2) {
        return {
          top: '-294px'
        }
      } else {
        return {
          top: '0px'
        }
      }
    }
  },
  watch: {
    types (newVal, oldVal) {
      if(newVal && !oldVal) {
        this.typeData = this.types[this.typeArrayIndex]
      }
    },
    typeMobileP2Showing(val) {
      this.showP2 = val 
    }
  },
  methods: {
    ...mapActions({
      syncTypes: 'syncTypes',
      setTypeNavigationShowing: 'doSetTypeNavigationShowing'
    }),
    clickType(i) {
      this.setTypeNavigationShowing(true)
      this.$router.push({name: 'Type', params: {typeArrayIndex: ''+i}})
    }
  }
}
</script>

<style lang="scss" scoped>
.hover-sky {
  color: #fff;
  @media screen and (min-width: 768px){
    color: #333;
  }
}
.mobile-title {
  font-size: 1.5rem;
  @media screen and (min-width: 768px){
    font-size: 0.85rem;
  }
}
.type-wrapper {
  height: calc(100vh - 100px);
  overflow: hidden;
  >div {
    transition: top 0.6s;
  }
}
.footer-control {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
}
</style>